import axios from 'axios';

const getBaseURL = (type = '', slash = true) => {
	let url = process.env.REACT_APP_URL_CHEETAH_API || 'https://cheetah-api.builderall.com';

	if (type == 'api') {
		url = `${url}/api`
	}

	if (slash) {
		url = `${url}/`
	}

	return url
}

const http = new (function () {

	let url = getBaseURL();

	this.webAction = function () {
		return axios.create({
			baseURL: url,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			}
		});
	};


	this.api = function () {
		return axios.create({
			baseURL: url + 'api/',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			}
		});
	};

	this.authApi = function () {
		let token = localStorage.getItem('token')
			? localStorage.getItem('token')
			: '';

		return axios.create({
			baseURL: url + 'api/',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${token}`
			}
		});
	};

	this.authProd = function () {
		let token = localStorage.getItem('tokenP')
			? localStorage.getItem('tokenP')
			: '';

		return axios.create({
			baseURL: getBaseURL('api', false),
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${token}`
			}
		});
	};
})();

export default http;
